/**
 * Seasonal Theme Configuration
 *
 * This file controls which seasonal theme is currently active.
 * Simply change ACTIVE_SEASON to switch between themes.
 */

export enum Season {
	FALL = 'fall',
	WINTER = 'winter',
	SPRING = 'spring',
}

/**
 * Set the active season here
 * This controls which theme assets, effects, and styling are used
 */
export const ACTIVE_SEASON: Season = Season.SPRING;

/**
 * Season display configuration
 * Used for localStorage keys, translations, etc.
 */
export const SEASON_CONFIG = {
	[Season.FALL]: {
		name: 'Fall',
		year: '2025',
		storageKey: 'bonusly:seasonal-theme:fall-2025',
	},
	[Season.WINTER]: {
		name: 'Winter',
		year: '2025',
		storageKey: 'bonusly:seasonal-theme:winter-2025',
	},
	[Season.SPRING]: {
		name: 'Spring',
		year: '2026',
		storageKey: 'bonusly:seasonal-theme:spring-2026',
	},
} as const;

/**
 * Get the current active season configuration
 */
export const getActiveSeasonConfig = () => SEASON_CONFIG[ACTIVE_SEASON];
